package songwritersnotebook.database

import kotlin.String

public data class RhymeWordEntity(
  public val word: String,
  public val phonemes: String,
  public val stressedSuffix: String,
)
